// extracted by mini-css-extract-plugin
module.exports = {"contact":"contact-module--contact--dXr_P","row":"contact-module--row--1bIcW","col":"contact-module--col--D5ZjP","swoosh":"contact-module--swoosh--3dLSf"};